/**
 * 샵관리 모듈 메뉴 (SH_)
 * hrMenuConfig 의 TOP/LEFT 에 병합한다. 추후 독립 시스템 분리 시 이 파일만 들어내면 된다.
 * 설계: docs/agent-plans/CM/20260919-샵관리-모듈설계.md
 * 화면 컴포넌트가 아직 없으면 PageComponents 가 Placeholder 로 표시한다.
 */
export const SH_TOP_MENUS = [
  { id: '800', label: '샵관리', icon: 'receipt', iconSrc: null, menuNo: '800', progId: 'SH' },
];

const leaf = (id, upper, label, screenId, menuType, url, comp) => ({
  id,
  label,
  menuNo: id,
  upperMenuId: upper,
  progId: screenId,
  screenId,
  menuType,
  url,
  componentPath: `pages/shop/${comp}`,
});

const dir = (id, upper, label, children) => ({
  id,
  label,
  menuNo: id,
  upperMenuId: upper,
  url: 'dir',
  children,
});

export const SH_LEFT_MENUS = {
  '800': [
    {
      id: '800',
      label: '샵관리',
      menuNo: '800',
      upperMenuId: '0',
      url: 'dir',
      children: [
        dir('810', '800', '제품관리', [
          leaf('811', '810', '제품마스터', 'SH_PRODUCT', 'crud', '/shop/product', 'ProductMaster'),
          leaf('812', '810', '입고관리', 'SH_STOCK_IN', 'crud', '/shop/stock-in', 'StockIn'),
          leaf('813', '810', '출고관리', 'SH_STOCK_OUT', 'crud', '/shop/stock-out', 'StockOut'),
          leaf('814', '810', '재고현황', 'SH_STOCK', 'report', '/shop/stock', 'StockStatus'),
          leaf('815', '810', '매입 영수증 OCR', 'SH_RECEIPT_OCR', 'crud', '/shop/receipt-ocr', 'ReceiptOcr'),
        ]),
        dir('820', '800', '고객관리', [
          leaf('821', '820', '고객등록', 'SH_CUSTOMER', 'crud', '/shop/customer', 'CustomerRegister'),
          leaf('822', '820', '회원권관리', 'SH_PASS', 'crud', '/shop/pass', 'PassManage'),
        ]),
        dir('830', '800', '서비스관리', [
          leaf('831', '830', '서비스마스터', 'SH_SERVICE', 'crud', '/shop/service', 'ServiceMaster'),
          leaf('832', '830', '시술기록', 'SH_RECORD', 'crud', '/shop/record', 'ServiceRecord'),
          leaf('833', '830', '서비스 사용제품', 'SH_SERVICE_ITEM', 'crud', '/shop/service-item', 'ServiceItemMaster'),
        ]),
        dir('840', '800', '매출관리', [
          leaf('841', '840', '매출등록', 'SH_SALE', 'crud', '/shop/sale', 'SaleRegister'),
          leaf('842', '840', '매출현황', 'SH_SALE_REPORT', 'report', '/shop/sale-report', 'SaleReport'),
        ]),
        dir('850', '800', '비용관리', [
          leaf('851', '850', '월 고정비', 'SH_EXPENSE', 'crud', '/shop/expense', 'ExpenseRegister'),
          leaf('852', '850', '반복비용 템플릿', 'SH_EXPENSE_TPL', 'crud', '/shop/expense-tpl', 'ExpenseTemplate'),
        ]),
        dir('860', '800', '손익', [
          leaf('861', '860', '월손익', 'SH_PNL', 'report', '/shop/pnl', 'MonthlyPnl'),
          leaf('862', '860', '대시보드', 'SH_DASH', 'report', '/shop/dashboard', 'ShopDashboard'),
        ]),
        dir('870', '800', '판매도구', [
          leaf('871', '870', '쿠팡 마진계산기', 'SH_MARGIN_CALC', 'inquiry', '/shop/margin-calc', 'MarginCalculator'),
        ]),
      ],
    },
  ],
};
